// theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#ffffff", 
      contrastText: "#fff",
    },
    secondary: {
      main: "#f57c00", // construction orange
      contrastText: "#fff",
    },
    background: {
      default: "#ffffff", // 
      paper: "#121212",   // for cards, sections, etc.
    },
    text: {
      primary: "#f5f5f5",  // bright text
      secondary: "#aaaaaa",
    },
  },
  typography: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: {
      fontWeight: 700,
      color: "#ffffff",
    },
    h2: {
      fontWeight: 600,
      color: "#ffffff",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: (themeParam) => ({
        body: {
          backgroundColor: themeParam.palette.background.default,
          color: themeParam.palette.text.primary,
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        },
        "*": {
          boxSizing: "border-box",
        },
      }),
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "#121212", // matches background.paper
          color: "#f5f5f5",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          textTransform: "none",
          fontWeight: 600,
        },
        containedPrimary: {
          backgroundColor: "#000000",
          "&:hover": {
            backgroundColor: "#000000",
          },
        },
        containedSecondary: {
          backgroundColor: "#f57c00",
          "&:hover": {
            backgroundColor: "#bb6500",
          },
        },
      },
    },
  },
});



export default theme;